import { useState } from "react"
import { GridLayout } from "../components/layout"
import { CourseComp } from "../components/courseComp"
import { SuggestedCourseComp } from "../components/suggestCourseComp"
import { Modal, ModalBody } from "../components/modal"
import { CourseModal } from "../components/courseModal"
import { add, set } from "date-fns"
import { LeadPopOver } from "../components/leadPopOver"

export const TeaserPage = ({courses}) => {
    // console.log("here are courses",courses)
    const [activeCourses,setActiveCourses] = useState(
        []
    )
    const [activeCourse, setActiveCourse] = useState(null)
    const [activeModal, setActiveModal] = useState(false)
    const [lead,setActiveLead] = useState(false)
    const handleCourseClick = (index) => {
        setActiveModal(!activeModal)
        setActiveCourse(index)
    }
    const addCourse = (course) => {
        var copyCourse = [...activeCourses]
        copyCourse = (!activeCourses.includes(course.id_course)) ? [...activeCourses, course.id_course]:activeCourses.filter(id => id !== course.id_course)
        setActiveCourses(  copyCourse)
        setActiveModal(!activeModal)
        if(copyCourse.length > 2){
            console.log(copyCourse)
            handleLead()
        }
    }
    const handleLead = () => {
        setActiveLead(!lead)

    }
    return (
        <>
        
        <h1 className="standard-text-color" style={{textAlign:"center", paddingTop:"3rem", color:"white",fontSize:"8rem"}}>expligo</h1>
        <h4 className="standard-text-color" style={{textAlign:"center", marginTop:"2rem", color:"white"}}>Selecteer minimaal 3 relevante e-learnings!</h4>
        <GridLayout
            className="course-grid"
            style={{ gridAutoRows: "220px", width:"75%", marginLeft:"auto", marginRight:"auto",  paddingTop:"2rem" }}
            columnsTemplate="1fr 1fr 1fr 1fr"
            gap="16px"
        >
            {courses.map((course,index) => {
                return(
                <SuggestedCourseComp
                    teaserClass={"teaser-comp"}
                    key={course.id_course}
                    onClick={() => handleCourseClick(index)}
                    title={course.title}
                    selected={activeCourses.includes(course.id_course)}
                    image={course?.image_url}
                />
            )})}
        </GridLayout>

        <CourseModal
            visible={activeModal}
            selected={activeCourses.includes(courses[activeCourse]?.id_course)}
            course={courses[activeCourse]}
            onClose={() => setActiveModal(!activeModal)}
            addCourse={() => addCourse(courses[activeCourse])}
        />
        <LeadPopOver
            chosenCourses = {activeCourses}
            visible={lead}
            count={activeCourses.length}
            dismissable={handleLead}
        />

        </>
    )
}

